import type { LocationFacing } from "@/lib/locations-api"

const PRIMARY_LOCATION_FACING: LocationFacing = "three_quarter"

export type LocationThumbnailSource = {
  reference_sheet_url?: string | null
  /** Variant-row preview (display after backend fix; last-resort fallback). */
  reference_url?: string | null
  reference_urls_by_facing?: Partial<Record<LocationFacing, string | null>>
  reference_thumb_urls_by_facing?: Partial<Record<LocationFacing, string | null>>
}

export function locationListThumbnail(
  source: LocationThumbnailSource,
  facing: LocationFacing = PRIMARY_LOCATION_FACING,
): string | null {
  const thumb = source.reference_thumb_urls_by_facing?.[facing]?.trim()
  if (thumb) return thumb

  const full = source.reference_urls_by_facing?.[facing]?.trim()
  if (full) return full

  if (facing === PRIMARY_LOCATION_FACING) {
    return source.reference_sheet_url?.trim() || source.reference_url?.trim() || null
  }
  return null
}

/** Display (≤800) for backdrops / larger previews — never raw variant `reference_url`. */
export function locationListDisplay(
  source: LocationThumbnailSource,
  facing: LocationFacing = PRIMARY_LOCATION_FACING,
): string | null {
  const full = source.reference_urls_by_facing?.[facing]?.trim()
  if (full) return full

  if (facing === PRIMARY_LOCATION_FACING) return source.reference_sheet_url?.trim() || null
  return null
}
